<template>
  <div class="">
    <div v-if="label != null" class="overflow-hidden">
      <div class="float-left label-standard">
        <RequiredAsterisk v-if="required"></RequiredAsterisk>
        {{ label }}
      </div>
      
      <div v-if="tooltip != null" class="float-left ml-4" style="margin-top:1px;">
        <div class="" v-tooltip.top="{ html: propertyKey + 'Tooltip' }">
          <img src="/static/img/icons/icons8-info-grey.png" style="width:15px;height:15px;" />
        </div>

        <div :id="propertyKey + 'Tooltip'" class="p-1">{{ tooltip }}</div>
      </div>
    </div>

    <div class="form-line relative">
      <input type="text"
        class="input-standard"
        ref="value"
        v-bind:value="localValue"
        v-on:blur="updateValue({
          objectType: objectType,
          objectId  : objectId,
          index     : index,
          key       : propertyKey,
          value     : $event.target.value
        })"
        v-on:keyup="localValue = formatPhoneNumber($event.target.value)" />
    </div>

    <div v-if="subLabel != null" class="mt-2 text-sm text-gray-700">{{ subLabel }}</div>
  </div>
</template>

<script>

  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    props : {

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type : Number,
        required : false
      },

      label : {
        type    : String,
        required: false
      },

      subLabel : {
        type    : String,
        required: false
      },

      tooltip : {
        type    : String,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },
      // Object name is required if data array consist of two different data model e.g "broker" & "user" and we use object name to specfiy for which model we are updating the data in this component.
      objectName : {
        type    : String,
        required: false
      },

      value : {
        // type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      index : {
        type    : Number,
        required: false,
      },

      copyFrom : {
        type    : String,
        required: false
      },

      // onKeyup is a function that will be called
      // for those cases where you need to do something
      // as the user types in
      onKeyup: {
        type : Function,
        required : false
      },

      required : {
        type    : Boolean,
        required: false,
        default : false
      }

    },

    components : {
      RequiredAsterisk
    },

    watch: {
      value : {
        
        deep     : true,
        immediate: true,

        handler(newValue, oldValue) {
          this.localValue = newValue
        },

      },
    },

    data() {
      return {
        localValue : this.value
      }
    },

    methods : {

      // for some components, we are updating something that is repeated via v-for.
      // For example, addresses. An applicant has multiple addresses, so we do
      // <v-for address in addresses>
      //   <InputText address>
      // But when we are doing the autosave, we actually need to know which address we are
      // updating. We can do this via index, which is passed as a prop.
      // For some, it's not repeated, so we don't need the index. So, instead of going
      // directly to updateValue, we are going via "localUpdateValue, so that we can check
      // if index exists, or not
      localUpdateValue(key, value) {
        if(this.index != null) {
          this.updateValue(this.objectType, this.index, key, value);
        }

        else if(this.objectName != null) {
          this.updateValue(this.objectName, key, value);
        } 

        else {
          this.updateValue(key, value);
        }
      },

      copyValue(fromApplicantId, applicantIndex) {
        this.localValue = this.$store.state[this.$store.state.view + 'Module'].client.applicants[applicantIndex].person[this.copyFrom]
      },
    }
  }
</script>